import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { queryKeys } from '@/queries/query-keys';
import { useAuthStore } from '@/stores/auth-store';

/** PUT `/admin/passwordReset/{email}/{code}/{newPassword}` — sets password and signs in. */
export function usePasswordResetMutation() {
  const queryClient = useQueryClient();

  return useApiMutation(
    ({ email, confirmationCode, newPassword }) =>
      `/admin/passwordReset/${encodeURIComponent(email.trim())}/${encodeURIComponent(confirmationCode.trim())}/${encodeURIComponent(newPassword)}`,
    'put',
    {},
    {
      onSuccess: (data) => {
        useAuthStore.getState().setSession(data);
        queryClient.invalidateQueries({ queryKey: queryKeys.session() });
        NotificationManager.success('Password updated', '', 3000);
      },
      onError: () => {
        NotificationManager.error(
          'Invalid code or email — try again',
          '',
          4000,
        );
      },
    },
  );
}
